import { editorCommandToPMCommand } from './editor-commands';
export var corePlugin = function corePlugin(_ref) {
  var config = _ref.config;
  return {
    name: 'core',
    actions: {
      execute: function execute(command) {
        var editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
        if (!editorView || !command) {
          return false;
        }
        var state = editorView.state,
          dispatch = editorView.dispatch;
        return editorCommandToPMCommand(command)(state, dispatch);
      }
    }
  };
};